<template>
  <div :class="['section-contact-container', { 'history': isHistory }]">
    <el-row id="section-contact-main" class="section" v-if="sectionData">
      <el-col :span="12">
        <div class="group-horizontal">
          <div class="small-text subHeader bold">อัพเดทล่าสุด &nbsp;</div>
          <div class="small-text subHeader normal">&nbsp; {{ sectionData.updatedAt }}</div>
        </div>
      </el-col>
      <el-col class="right" :span="12" v-if="!isHistory">
        <el-button type="primary" class="secondary-button" @click="editButtonClick">แก้ไข</el-button>
      </el-col>
    </el-row>
    <el-row class="section contact">
      <el-row class="right header" :span="12">
        <el-col class="right" :span="10">ข้อมูลผู้ติดต่อ</el-col>
      </el-row>
      <el-row>
        <el-col :class="['header-18-gray', 'right', { 'change': hasChange('contactName') }]" :span="10">ชื่อผู้ติดต่อ</el-col>
        <el-col class="detail" :span="10" :offset="1">{{ sectionData.contact.name }}</el-col>
      </el-row>
      <el-row>
        <el-col :class="['header-18-gray', 'right', { 'change': hasChange('contactPhone') }]" :span="10">หมายเลขโทรศัพท์</el-col>
        <el-col class="detail" :span="10" :offset="1">{{ sectionData.contact.phone }}</el-col>
      </el-row>
      <el-row>
        <el-col class="header-18-gray right" :span="10">ไลน์ไอดี</el-col>
        <el-col class="detail" :span="10" :offset="1">{{ sectionData.lineId }}</el-col>
      </el-row>
      <el-row>
        <el-col :class="['header-18-gray', 'right', { 'change': hasChange('contactEmail') }]" :span="10">อีเมล</el-col>
        <el-col class="detail" :span="10" :offset="1">{{ sectionData.contact.email }}</el-col>
      </el-row>
      <el-row class="section contact">
        <el-row>
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('customerType') }]" :span="10">ประเภทลูกค้า</el-col>
          <el-col class="detail" :span="10" :offset="1">
            <div class="p-section-contact" v-if="sectionData.customerType === 'ลูกค้าทั่วไป'">{{ sectionData.customerType }}</div>
            <div class="p-section-contact" v-else-if="sectionData.customerType !== 'ลูกค้าทั่วไป' && sectionData.customerType !== ''">{{ sectionData.customerType }}, {{ sectionData.customerCompany.preset }}</div>
            <div v-show="sectionData.customerType !== 'ลูกค้าทั่วไป' && sectionData.customerType !== '' && sectionData.customerCompany.preset !== 'บริษัท MTL'">
              <div class="p-section-contact" >ชื่อบริษัท: {{ sectionData.customerCompany.name }}</div>
              <div class="p-section-contact" >เลขผู้เสียภาษี: {{ sectionData.customerCompany.taxId }}</div>
              <div class="p-section-contact" >สำนักงาน/สาขาเลขที่: {{ sectionData.customerCompany.branch }}</div>
              <div class="p-section-contact" >ที่อยู่สำหรับการออกใบกำกับภาษี: {{ sectionData.customerCompany.address }}</div>
              <div class="p-section-contact" >อีเมลสำหรับการรับใบกำกับภาษี: {{ sectionData.customerCompany.email }}</div>
              <div class="p-section-contact" >ที่อยู่สำหรับการรับเอกสารทางไปรษณีย์: {{ sectionData.customerCompany.mailAddress }}</div>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
  .right {
    text-align: right;
  }

  .small-text {
    font-size: 14px;
  }

  .el-button {
    width: 120px;
  }

  .section-contact-container {
    background: #F1F3F6;

    .section {
      padding-top: 20px;
      padding-left: 40px;
      padding-right: 40px;
      padding-bottom: 20px;

      &.contact {
        padding-bottom: 66px;

        .header {
          font-family: 'Sukhumvit-Bold';
          padding-bottom: 20px;
          padding-top: 20px;
          font-size: 22px;
          font-weight: 600;
          color: #606266;
          margin-bottom: 0;
        }

        .detail {
          font-family: 'Sukhumvit-Medium';
          color: #676E81;
          font-weight: 300;
          font-size: 18px;
        }

        .change {
          color: #FF577F !important;
        }
      }
    }

    &.history {
      background: #F9F9FA;

      div {
        color: #A2A7B2;
      }
    }
  }

  .bold {
    font-weight: 900;
  }

  .normal {
    font-weight: 100;
  }

  .el-row {
    margin-bottom: 16px;
  }

  .edit {
    border: 2px solid #409eff;
    color: #409eff;
    font-weight: 900;
    font-size: 18px;
    background-color: #f5f7fa;
  }

  .subHeader {
    color: #c0c4cc;
  }

  .group-horizontal {
    display: flex;
    flex-direction: row;
  }

  .p-section-contact {
    margin-bottom: 8px;
  }
</style>

<script>
export default {
  name: 'sectionContact',
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
    isHistory: {
      type: Boolean,
      required: false,
    },
    historiesData: {
      type: Array[String],
      required: true,
    },
  },
  methods: {
    editButtonClick () {
      this.$emit('editButtonClick')
    },
    hasChange (data) {
      return this.historiesData && this.historiesData.indexOf(data) > -1
    },
  },
}
</script>
